import { FC } from 'react'
import { Tab, Skeleton, Wrapper } from '@lounge-fe/ui-kit'
import { useTranslation } from 'react-i18next'
import { useController } from 'react-hook-form'
import { TagFilterBarProps, Tag } from './types'
import { useDataTranslation } from '@/features/localisation/hooks/useDataTranslation/useDataTranslation'
import classNames from 'classnames'

export const TagFilterBar: FC<TagFilterBarProps> = ({
  name,
  tags,
  isLoading,
}) => {
  const { t } = useTranslation()
  const { isLoading: isTranslationLoading, t: dataT } = useDataTranslation()
  const { field } = useController({
    name,
    defaultValue: [],
  })

  const onTagSelect = (tag: Tag) => {
    field.onChange([...field.value, tag.value])
  }

  const onTagDeselect = (tag: Tag) => {
    field.onChange(field.value.filter((value: string) => value !== tag.value))
  }

  if (!tags.length && !isLoading) {
    return null
  }

  return (
    <div className="overflow-x-auto border-t border-[#E7E7E7]">
      <fieldset>
        <legend className="sr-only" role="group">
          {t('action.filter_products_by_type')}
        </legend>
        <Wrapper
          className={classNames(
            tags.length > 2
              ? 'justify-start sm:justify-center'
              : 'justify-center',
            'flex py-6 sm:gap-x-8 gap-x-6 px-5 sm:px-14',
          )}
        >
          {isLoading || isTranslationLoading ? (
            [...Array(6)].map((_, idx) => (
              <Skeleton key={idx}>
                <Skeleton.Block className="h-12 w-20 rounded-sm" />
              </Skeleton>
            ))
          ) : (
            <>
              <Tab
                role="checkbox"
                selected={!field.value.length}
                aria-checked={!field.value.length}
                onClick={() => field.onChange([])}
              >
                {t('general.all')}
              </Tab>
              {tags.map((tag) => {
                const selected = Boolean(field.value.includes(tag.value))
                return (
                  <Tab
                    key={tag.value}
                    selected={selected}
                    role="checkbox"
                    aria-checked={selected}
                    onClick={() =>
                      selected ? onTagDeselect(tag) : onTagSelect(tag)
                    }
                  >
                    {dataT(tag.label)}
                  </Tab>
                )
              })}
            </>
          )}
        </Wrapper>
      </fieldset>
    </div>
  )
}
